import lottie from 'lottie-web';

export const heroAnimation = () => {
  const siteHeader = document.querySelector('.site-header');
  const lottieContainer = document.getElementById('lottie-container');
  const splash = document.getElementById('splash');
  const splashBtn = document.getElementById('splash--advance');
  const header = document.querySelector('.site-header');

  if (!lottieContainer) {
    return;
  } else {
    // add lock class to body tag
    document.body.classList.add('lock');
    document.body.classList.add('setup');

    window.addEventListener('scroll', () => {
      if (window.scrollY > 100) {
        document.body.classList.add('exit-lottie');
      }
    });
  }

  // Add event listeners for mouseover and mouseout
  siteHeader.addEventListener('mouseover', () => {
    lottieContainer.classList.add('reverse'); // Add the "reverse" class
  });

  siteHeader.addEventListener('mouseout', () => {
    lottieContainer.classList.remove('reverse'); // Remove the "reverse" class
  });
  const animation = lottie.loadAnimation({
    container: lottieContainer, // The container element
    renderer: 'svg', // Render type: 'svg', 'canvas', or 'html'
    loop: false, // Set to false for one-time play
    autoplay: true, // Start automatically
    path: '../../wp-content/themes/general-atlantic-theme/ga-hero-animation-cropped.json', // Path to the animation file
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid meet', // Covers the container while preserving aspect ratio
    },
  });

  // Set the playback speed (1 is normal speed, 2 is double speed, etc.)
  animation.setSpeed(1.75); // Adjust the speed as needed

  setTimeout(() => {
    lottieContainer.classList.add('moved'); // Add the "moved" class to trigger the transition
    splash.classList.add('faded'); // Hide the splash screen
    splashBtn.classList.add('faded'); // Hide the splash screen
    document.body.classList.remove('setup'); // Remove the "lock" class
  }, 3500);

  // Add a complete event listener
  animation.addEventListener('complete', () => {
    // alert('complete');
    //update
    document.body.classList.remove('lock'); // Remove the "lock" class
    // document.body.classList.remove('setup'); // Remove the "lock" class
  });

  const splashAdvance = document.querySelector('#splash--advance');

  if (splashAdvance) {
    splashAdvance.addEventListener('click', () => {
      document.body.classList.add('exit-lottie');
      splashBtn.classList.add('faded'); // Hide the arrow
    });
  }
};
